<acabim-datatable
    #dataTable
    [dataSources]="[this]"
    [dataKey]="'id'"
    [hasDetailView]="false">
</acabim-datatable>

<div class="pt-3">
    <acabim-admin-subscription-request [organisation]="selectedOrganisation" [currentUsageInfo]="rowData"
                                       (resourceSubscriptionCreated)="onRequestToRefreshData()"></acabim-admin-subscription-request>
</div>
